import React, { useCallback } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";
import styles from '../../SportsAndRecPage.module.scss'
import presentationMetadata from './PropertyCoveragesPage.metadata.json5';
import messages from './PropertyCoveragesPage.messages';
import CoveragesPageComponent from '../Coverages/CoveragesPage'

function PropertyCoveragesPage(props) {
    const {
        wizardData: submissionVM, updateWizardData, currentStep, callbackMap
    } = props;
    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('PropertyPage');

    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const onNext = useCallback(
            async () => {
    
                const { productCode } = submissionVM.value.baseData;
                const lobLineName = lineName[productCode];
    
                submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);
    
                return submissionVM;
            },
            [lineName, submissionVM, updateSubmission]
        );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        locRiskCoverageComponent: {
            wizardData: submissionVM,
                updateWizardData,
                clausesBasePath: `lobData.spoAndRecLine.lineCoverages.locRiskCoverages.psrcoverages.children[0].coverages`,
                title: messages.cov,
                clasueType: "coverages",
                pathToGet: `spoAndRecLine.locRiskCoverages.psrcoverages[0].coverages`,
        },
        additionalInterest: {
            wizardData: submissionVM,
            updateWizardData,
            addlIntPath: `lobData.spoAndRecLine.coverables.locRisks.children[0].additionalInterests`,
            isLineLevel: false
        }
    };

    const resolveCallbackMap = {
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, submissionVM, id, path, overrideProps),
        [metadata.content, submissionVM, overrideProps]
    );

    const resolveComponentMap = {
        coveragespagecomponent: CoveragesPageComponent,
        AddlInterestTextBoxComponent
    };

    const isDisableNext = () => !_.get(submissionVM, 'lobData.spoAndRecLine.coverables.locRisks.children[0].additionalInterests.aspects.subtreeValid');

    return (
        <WizardPage onNext={onNext} onSave={onNext}
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            disableSave={isDisableNext()}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                componentMap={resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PropertyCoveragesPage.propTypes = wizardProps;
export default withViewModelService(PropertyCoveragesPage);
